import classNames from "@corgical/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  // Default to the bundled Corgi calendar wordmark/icon. An explicit `src`
  // (e.g. a per-org custom logo) still takes precedence.
  const logoSrc = icon ? (src ? `${src}?type=icon` : "/corgi-icon.svg") : src ?? "/corgi-logo.svg";
  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        <img
          className={classNames(icon ? "mx-auto w-9" : small ? "h-4 w-auto" : "h-5 w-auto")}
          alt="Calendar by Corgi"
          title="Calendar by Corgi"
          src={logoSrc}
        />
      </strong>
    </h3>
  );
}
